import api from 'core/api';

export const getRatings = ({ klass, klassId, pagination }) =>
  api.get(`/ratings/${klass}/${klassId}`, { params: pagination });
export const getRated = ({ klass, klassId }) => api.get(`/ratings/${klass}/${klassId}/rated`);
export const postRating = (data) => api.post('/ratings', data);
